// Generated by ReScript, PLEASE EDIT WITH CARE


function reducer(state, action) {
  switch (action.TAG | 0) {
    case /* CurrentStepperState */0 :
        return {
                currentStepperState: action.currentStepperState,
                templateList: state.templateList,
                selectedTemplate: state.selectedTemplate
              };
    case /* SetTemplateList */1 :
        return {
                currentStepperState: state.currentStepperState,
                templateList: action.templateList,
                selectedTemplate: state.selectedTemplate
              };
    case /* SelectTemplate */2 :
        return {
                currentStepperState: state.currentStepperState,
                templateList: state.templateList,
                selectedTemplate: action.selectedTemplate
              };
    
  }
}

export {
  reducer ,
  
}
/* No side effect */
